import React, { Component} from 'react';

import Select from './../Select';

const data = [{
    value: "大专",
    label: "大专"
}, {
    value: "本科",
    label: "本科"
}, {
    value: "硕士",
    label: "硕士"
}, {
    value: "博士",
    label: "博士"
}, {
    value: "博士后",
    label: "博士后"
}, {
    value: "高中",
    label: "高中"
}, {
    value: "初中",
    label: "初中"
}, {
    value: "中专",
    label: "中专"
}, {
    value: "其他",
    label: "其他"
}];


const EduDegree = (props) => (
    <Select name="eduDegree" label="学历" data={data} {...props} ></Select>
);

export default EduDegree;